import * as $ from 'jquery';
window.jQuery = $;
// import 'pogo-slider/jquery.pogo-slider.min';
require('pogo-slider/jquery.pogo-slider.min');


function PogoSliderCtrl() {
	this.$target = $('.pogoSlider');
	this.sliderLength = this.$target.find('.pogoSlider-slide').length;
	this.flagPlay = (this.sliderLength > 1) ? true : false;
	// Get window.sliderOptions
	this.sliderOptions = sliderOptions;

	this.options = this.options.bind(this);

	this.init();
}

PogoSliderCtrl.prototype.init = function() {
	var frontSlider = this.$target.pogoSlider(this.options()).data('plugin_pogoSlider');
}

PogoSliderCtrl.prototype.options = function() {
	var options = {
		displayProgress        : true,
		preserveTargetSize     : true,
		responsive             : true,
		slideTransition        : this.sliderOptions.mode,
		slideTransitionDuration: this.sliderOptions.speed,
		buttonPosition         : 'CenterHorizontal',
		navPosition            : 'Bottom',
		targetWidth            : 1200,
		targetHeight           : 544,
		pauseOnHover           : false
	};

	if (this.sliderLength > 1) {
		options.autoplayTimeout = this.sliderOptions.delay;
		options.autoplay        = true;
	}

	return options;
}

new PogoSliderCtrl();